import { STACKEDPRICESDATA_RECEIVE } from "../Actions/StackedPrices.action";
import { PRODUCTQUANTITY_SETBASEQUANTITY, PRODUCTQUANTITY_SETBASEUNIT, PRODUCTQUANTITY_SETTOTALWEIGHT, PRODUCTQUANTITY_SETUNIT } from "../Actions/ProductQuantity.action";
import {
  CONFIGURATOR_LOAD,
  CONFIGURATOR_CLOSE,
  CONFIGURATOR_SET,
  DELIVERYCONFIG_SET,
  CONFIGURATOR_CLEAR,
  CONFIGURATOR_SET_TEMP,
  CONFIGURATOR_SET_SAVEBUTTONDISABLE,
  ADD_RECOMMENDED_PRODUCT,
  REMOVE_RECOMMENDED_PRODUCT,
  UPDATE_RECOMMENDED_PRODUCT_QUANTITY,
} from "../Actions/ProductConfigurator.action";

let initialState = {
  loading: true,
  alloySurcharge: 0,
  defaultPurchaseUnit: "",
  baseUnit: { description: "" },
  quantityFieldId: "",
  totalWeight: 0,
  baseUnitQuantity: 2,
  baseUnitWeight: 0,
  selectedUnit: "",
  quantitySelector: {},
  selections: {
    isConfigured: false,
    cutCode: "",
    selectedBeamType: 1,
    selectedBeamAngle: {},
    cutAngleA: -1,
    cutAngleB: -1,
    color: -1,
    blastPaintCode: "",
    cuttingLength: "",
    inkjetIntegrationFlag: false,
    workPhaseMarkingChargeNumber: false,
    workPhaseMarkingText: "",
    drawingNumber: "",
    foilingCoils: "Blank",
    packingCoils: "",
    maxWeightCoils: "",
    maxHeightCoils: "",
  },
  deliveryDetails: {
    certificateRequested: false,
  },
  stackedPrices: { currencyCode: "", quantityPriceList: [] },
  disableButton: true,
  infoTextQuantityMinLimit: 0,
  selectedRecommendedProducts: [],
};

export const productConfigurator = (state = initialState, action) => {
  switch (action.type) {
    case PRODUCTQUANTITY_SETTOTALWEIGHT:
    case STACKEDPRICESDATA_RECEIVE:
    case PRODUCTQUANTITY_SETBASEQUANTITY:
    case PRODUCTQUANTITY_SETBASEUNIT:
    case PRODUCTQUANTITY_SETTOTALWEIGHT:
    case PRODUCTQUANTITY_SETUNIT:
    case CONFIGURATOR_LOAD:
      return {
        ...state,
        ...action.payload,
        loading: false
      };
    case CONFIGURATOR_CLOSE:
      return {
        ...state,
        loading: true
      };
    case DELIVERYCONFIG_SET:
      state.deliveryDetails = {
        ...state.deliveryDetails,
        ...action.payload,
      };
      return state;
    case CONFIGURATOR_SET:
      state.selections = {
        ...state.selections,
        ...action.payload,
        isConfigured: true,
      };
      return {
        ...state,
      };
    case CONFIGURATOR_SET_TEMP:
      state.selections = {
        ...state.selections,
        ...action.payload,
      };
      return {
        ...state,
      };
    case CONFIGURATOR_SET_SAVEBUTTONDISABLE:
      state.disableButton = action.payload;
      return {
        ...state,
      };
    case CONFIGURATOR_CLEAR:
      return {
        ...state,
        selections: {
          isConfigured: false,
          selectedBeamAngle: {},
        },
      };
    case ADD_RECOMMENDED_PRODUCT:
      return {
        ...state,
        selectedRecommendedProducts: [
          ...state.selectedRecommendedProducts.filter(p => p.articleNumber !== action.payload.articleNumber),
          action.payload,
        ],
      };
    case REMOVE_RECOMMENDED_PRODUCT:
      return {
        ...state,
        selectedRecommendedProducts: state.selectedRecommendedProducts.filter(
          p => p.articleNumber !== action.payload
        ),
      };
    case UPDATE_RECOMMENDED_PRODUCT_QUANTITY:
      return {
        ...state,
        selectedRecommendedProducts: state.selectedRecommendedProducts.map(p =>
          p.articleNumber === action.payload.articleNumber ? { ...p, quantity: action.payload.quantity } : p
        ),
      };
    default:
      return state;
  }
};
